import { useEffect, useState } from 'react';
import { Trans } from '@lingui/macro';
import { ActionIcon, Button, Stack } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'tabler-icons-react';

import { UiCard } from '../../components/ui/ui-card/ui-card';
import { useApiClient } from '../../core/libs/api/api-client.provider';
import { HttpResource } from '../../core/libs/http-resource';
import { getTripsRequest } from '../../domains/available-routes/requests/get-trips.request';
import { ESeatStatus } from '../../domains/buy-ticket/types';
import { TTrip } from '../../domains/trips/trip';
import { AppNotify } from '../../features/app-notify/app-notify';
import { MainSideMenu } from '../../features/main-side-menu/main-side-menu';
import { SeachRoutesLoading } from './seach-routes-loading';
import { SearchRoutesResult } from './search-routes-result';
import { ETripSeatchItemAvailable, TTripSeatchItem } from './types';

import styles from './search.page.module.css';

export const SearchPage = () => {
  const navigate = useNavigate();
  // const [tripStations, setTripStations] = useState<TripStations | null>(null);
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.backButton}>
          <ActionIcon
            variant="transparent"
            radius="50%"
            size="40px"
            bg="transparent"
            onClick={() => navigate('/')}
          >
            <ArrowLeft size={24} strokeWidth={2} color="white" />
          </ActionIcon>
        </div>
        <div className={styles.routeTitle}>
          {/* <span style={{ lineHeight: 1, marginBottom: 6, color: '#C3DDF8' }}>
            маршрут
          </span> */}
          <h1 className={styles.headerTitle}>
            <Trans>Поиск маршрутов</Trans>
          </h1>
        </div>
        <div className={styles.mainSideMenu}>
          <MainSideMenu />
        </div>
      </header>
      <main className={styles.main}>
        <SearchTrains />
      </main>
    </div>
  );
};

type GetTripsRequestParams = Parameters<typeof getTripsRequest>[0];

// type SearchTrainsProps = {
//   onLoaded?: (params: TripStations) => void;
// };

const prepareTripAvailable = (trip: TTrip): TTripSeatchItem => {
  if (trip.seatTicketSupported) {
    const hasEmptySeats = trip.wagons?.some((wagon) =>
      wagon.seats.some((seat) => seat.status === ESeatStatus.free)
    );

    return {
      ...trip,
      available: hasEmptySeats
        ? ETripSeatchItemAvailable.available
        : ETripSeatchItemAvailable.noEmptySeats,
    };
  }

  return { ...trip, available: ETripSeatchItemAvailable.available };
};

const SearchTrains = observer(() => {
  const apiClient = useApiClient();
  const [searchParams] = useSearchParams();
  const [foundTrips, setFoundTrips] = useState<TTripSeatchItem[]>([]);
  const navigate = useNavigate();

  const [getStations] = useState(
    () =>
      new HttpResource<GetTripsRequestParams, { content: TTrip[] }>({
        apiClient,
        httpRequest: getTripsRequest,
        errorNotify: new AppNotify(),
        onFinish({ content }) {
          const preparedTrips = content
            .slice(0, 50)
            .map((trip) => prepareTripAvailable(trip))
            .sort((a, b) => Date.parse(a.startTime) - Date.parse(b.startTime));

          setFoundTrips(preparedTrips);
        },
      })
  );

  useEffect(() => {
    const stationFromId = searchParams.get('startStation');
    const stationToId = searchParams.get('endStation');
    const lowDateParams = searchParams.get('lowDate');
    const highDateParams = searchParams.get('highDate');

    const lowDate = lowDateParams
      ? new Date(Number(lowDateParams)).toJSON()
      : null;
    const highDate = highDateParams
      ? new Date(Number(highDateParams)).toJSON()
      : null;

    const params = {
      stationFromId: Number(stationFromId),
      stationToId: Number(stationToId),
      lowDate,
      highDate,
    };

    const tId = setTimeout(() => {
      getStations.send(params);
    }, 1500);

    return () => clearTimeout(tId);
  }, [getStations, searchParams]);

  return (
    <>
      {getStations.isWaitingForLoad && <SeachRoutesLoading />}

      {!getStations.isWaitingForLoad && foundTrips.length === 0 && (
        <Stack>
          <UiCard>
            <Trans>Маршруты не найдены</Trans>
          </UiCard>
          <UiCard>
            <Button fullWidth onClick={() => navigate('/')}>
              <Trans>Повторить поиск</Trans>
            </Button>
          </UiCard>
        </Stack>
      )}

      {!getStations.isWaitingForLoad && (
        <SearchRoutesResult trips={foundTrips} />
      )}
    </>
  );
});
